import { pb } from '../../../shared/api/pocketbase';
import type { LeaderBoardParticipant } from './types';

export const fetchParticipants = () =>
  pb.collection('leaderBoardParticipants').getFullList<LeaderBoardParticipant>({
    sort: '-created',
    expand: 'group',
    fields: 'id,group,actual,created,updated,expand.group.id,expand.group.name',
  });

export const createParticipant = (data: { group: string; actual: boolean }) =>
  pb.collection('leaderBoardParticipants').create<LeaderBoardParticipant>(data);

export const updateParticipant = (id: string, data: Partial<Pick<LeaderBoardParticipant, 'actual'>>) =>
  pb.collection('leaderBoardParticipants').update<LeaderBoardParticipant>(id, data);

export const deleteParticipant = (id: string) =>
  pb.collection('leaderBoardParticipants').delete(id);
